// extracted by mini-css-extract-plugin
var _1 = "PrivacyChangeAlert__close--jj1Zt";
var _2 = "PrivacyChangeAlert__closeImg--qP3dE";
var _3 = "PrivacyChangeAlert__link--jNBGL";
var _4 = "PrivacyChangeAlert__main--e01Yw CoreGeneral__roboto--UlmjE CoreGeneral__textSizeB--joAuE";
var _5 = "PrivacyChangeAlert__text--S2TWa";
export { _1 as "close", _2 as "closeImg", _3 as "link", _4 as "main", _5 as "text" }
